var render = function render(_c,_vm){return _c('span',_vm._g(_vm._b({class:['Icon', _vm.data.class, _vm.data.staticClass]},'span',_vm.data.attrs,false),_vm.listeners),[_c('i',{class:`i-${_vm.props.name}`}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }